import { Controller } from "stimulus"
import Rails from "rails-ujs"

export default class extends Controller {
  static targets = [
    "newSubscriptionList",
    "newSubscriptionListLoader",
    "currentPortfolioCount",
    "currentPortfolioCountInput",
    "currentPortfolioBilling",
    "currentPortfolioBillingInput",
    "newPortfolioCount",
    "newPortfolioBilling",
    "summaryPortfolioCount",
    "summaryPortfolioBilling",
    "summaryNewPortfolioCount",
    "summaryNewPortfolioBilling",
    "portfolio",
    "portfolioCaption",
    "modalConfirmButton",
    "submitButton",
    "removedPortfolioList",
    "addedPortfolioList",
    "addedPortfolio",
    "removedPortfolio",
    "removedPortfolioCount",
    "addedPortfolioCount",
    "alertStandardPrice",
    "alertIcon",
    "alertTitle",
    "alertText",
    "alertStandardPrice",
    // 🔍 Recherche
    "search",
    "portfolioRow",
    "groupSection"
  ]

  connect() {
    let clientId = this.data.get("client-id")
    let currentPortfolioCount = this.data.get("current-portfolio-count")


    this.currentPortfolioCountTarget.innerText = currentPortfolioCount
    this.currentPortfolioCountInputTarget.value = currentPortfolioCount

    let newBilling = this.subscriptionPrice(currentPortfolioCount)
    this.getCurrentBilling(clientId, newBilling)

    if (this.hasSummaryPortfolioBillingTarget) {
      this.summaryPortfolioCountTarget.innerText = currentPortfolioCount
      this.summaryNewPortfolioCountTarget.innerText = currentPortfolioCount
      this.newPortfolioCountTarget.innerText = currentPortfolioCount
      this.newPortfolioBillingTarget.innerText = newBilling + " € HT"
      this.summaryNewPortfolioBillingTarget.innerText = newBilling + " € HT"
    }
  }

  getCurrentBilling(clientId, standardPrice) {
    let _this = this
    this.currentPortfolioBillingTarget.innerHTML = this.loadingElementSimple()
    if (this.hasSummaryPortfolioBillingTarget) {
      this.summaryPortfolioBillingTarget.innerHTML = this.loadingElementSm()
      this.newSubscriptionListLoaderTarget.innerHTML = this.loadingElementSm()
    }

    Rails.ajax({
      type: "GET",
      url: "/clients/" + clientId + "/billed_product",
      success: (data) => {
        let products = data.products
        let amount = products.reduce(function (prev, cur) {
          return prev + cur.monthly_cost;
        }, 0)
        let isStandardPrice = amount === parseFloat(standardPrice)

        _this.currentPortfolioBillingTarget.innerText = amount + " € HT"
        _this.currentPortfolioBillingInputTarget.innerText = amount
        _this.hideLoading(_this.currentPortfolioBillingTarget)

        if (_this.hasSummaryPortfolioBillingTarget) {
          _this.summaryPortfolioBillingTarget.innerText = amount + " € HT"
          _this.newSubscriptionListLoaderTarget.innerHTML = ''
          _this.newSubscriptionListTarget.classList.remove("d-none")
        }

        if (!isStandardPrice) {
          _this.setWarningAlert()
        }
      }
    })
  }

  setWarningAlert() {
    this.alertStandardPriceTarget.classList.remove("border-secondary")
    this.alertStandardPriceTarget.classList.add("border-red", "bg-red-light")

    const url = this.alertIconTarget.dataset.warningUrl
    this.alertIconTarget.innerHTML = `<img src="${url}" class="mr-3 flex-shrink-0" width="35" height="35" />`

    this.alertTitleTarget.textContent = "Attention à votre modification"
    this.alertTextTarget.textContent = "Vous bénéficiez actuellement d'une tarification antérieure. La modification de votre abonnement entraînera une tarification standard. Contactez-nous à contact@eos-allocations.fr pour plus d'informations."
  }

  setNewSubscriptionDetails(event) {
    event.preventDefault()
    let countCheckedPortfolios = this.countNewPortfoliosSelection().length
    this.setCaptionAndList(event.target)

    if (countCheckedPortfolios < 6) {
      this.setDisableForm()
    } else {
      this.modalConfirmButtonTarget.disabled = false
      this.submitButtonTarget.disabled = false
      this.setNewBilling(countCheckedPortfolios)
    }
  }

  countNewPortfoliosSelection() {
    return this.portfolioTargets.map(target => target.firstElementChild.checked).filter(Boolean)
  }

  setNewBilling(portfolioCount) {
    let newBilling = this.subscriptionPrice(portfolioCount)

    this.newPortfolioCountTarget.innerHTML = portfolioCount
    this.newPortfolioBillingTarget.innerText = newBilling + " € HT"
    this.summaryNewPortfolioCountTarget.innerHTML = portfolioCount
    this.summaryNewPortfolioBillingTarget.innerText = newBilling + " € HT"
  }

  subscriptionPrice(portfolioCount) {
    let ptfCount = parseInt(portfolioCount)
    if (ptfCount < 6) {
      return this.preferedPrice(0) * ptfCount
    } else {
      let mainSubscription = this.preferedPrice(0) * 6
      let preferedPricePortfolios = ptfCount - 6
      let price = this.preferedPrice(preferedPricePortfolios)
      let preferedPriceSubscripion = preferedPricePortfolios * price
      return mainSubscription + preferedPriceSubscripion
    }
  }

  setDisableForm() {
    this.modalConfirmButtonTarget.disabled = true
    this.submitButtonTarget.disabled = true
    this.newPortfolioCountTarget.innerHTML = 'Sélectionnez au moins 6 profils'
    this.newPortfolioBillingTarget.innerText = '- € HT'
    this.summaryNewPortfolioCountTarget.innerHTML = 'Sélectionnez au moins 6 profils'
    this.summaryNewPortfolioBillingTarget.innerText = '- € HT'
  }

  setCaptionAndList(target) {
    let portfolioId = target.dataset.id
    let portfolioName = target.dataset.name
    let portfolioCaption = this.newSubscriptionListTarget.querySelector(".portfolio-caption-" + portfolioId)
    let currentPortfolios = this.currentPortfolioCountTarget.dataset.portfolioIds.split(',')
    let isCurrentPortfolio = currentPortfolios.includes(portfolioId)

    if (target.checked) {
      portfolioCaption.classList.add("text-primary", "font-weight-bold")
      portfolioCaption.classList.remove("text-danger")
    } else {
      portfolioCaption.classList.remove("text-primary", "font-weight-bold")
      if (isCurrentPortfolio) {
        portfolioCaption.classList.add("text-danger", "font-weight-bold")
      }
    }

    this.setListChanges(target.checked, portfolioId, portfolioName, isCurrentPortfolio)
  }

  setListChanges(checked, portfolioId, portfolioName, isCurrentPortfolio) {
    let addedPortfolioList = this.addedPortfolioListTarget
    let removedPortfolioList = this.removedPortfolioListTarget
    let addedPortfolios = this.addedPortfolioTargets
    let removedPortfolios = this.removedPortfolioTargets

    if (checked) {
      if (!isCurrentPortfolio) {
        addedPortfolioList.insertAdjacentHTML('beforeend', this.portfolioAddedElement(portfolioId, portfolioName))
      }

      let removedLine = removedPortfolios.find(portfolioLine => portfolioLine.dataset.portfolioId == portfolioId)
      if (removedLine) { removedLine.remove() }

    } else {
      if (isCurrentPortfolio) {
        removedPortfolioList.insertAdjacentHTML('beforeend', this.portfolioRemovedElement(portfolioId, portfolioName))
      }
      let addedLine = addedPortfolios.find(portfolioLine => portfolioLine.dataset.portfolioId == portfolioId)
      if (addedLine) { addedLine.remove() }
    }

    this.setRemovedTitle(removedPortfolioList)
    this.setAddedTitle(addedPortfolioList)
  }

  setRemovedTitle(removedPortfolioList) {
    let removedPortfolioCount = this.removedPortfolioCountTarget
    removedPortfolioCount.innerText = this.removedCount(removedPortfolioList.children.length)

    if (removedPortfolioList.children.length > 0) {
      removedPortfolioCount.parentElement.classList.remove("d-none")
    } else {
      removedPortfolioCount.parentElement.classList.add("d-none")
    }
  }

  setAddedTitle(addedPortfolioList) {
    let addedPortfolioCount = this.addedPortfolioCountTarget
    addedPortfolioCount.innerText = this.addedCount(addedPortfolioList.children.length)

    if (addedPortfolioList.children.length > 0) {
      addedPortfolioCount.parentElement.classList.remove("d-none")
    } else {
      addedPortfolioCount.parentElement.classList.add("d-none")
    }
  }

  filterPortfolios() {
    const query = this._normalize(this.searchTarget.value)

    clearTimeout(this._filterTimer)
    this._filterTimer = setTimeout(() => {
      this.portfolioTargets.forEach(row => {
        const haystack = this._normalize(row.dataset.search || "")
        const match = haystack.includes(query)
        row.classList.toggle("d-none", !match)
      })

      this.groupSectionTargets.forEach(section => {
        const visible = section.querySelectorAll('[data-portfolio-subscription-target="portfolio"]:not(.d-none)').length > 0
        section.classList.toggle("d-none", !visible)
      })
    }, 80)
  }

  _normalize(str) {
    return (str || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
  }


  preferedPrice(portfolioCount) {
    if (portfolioCount == 0) {
      return (220.0 / 6.0)
    } else if (this.inRange(portfolioCount, 1, 2)) {
      return 30.0
    } else if (this.inRange(portfolioCount, 2, 4)) {
      return 26.0
    } else if (this.inRange(portfolioCount, 4, 6)) {
      return 23.0
    } else if (this.inRange(portfolioCount, 6, 8)) {
      return 20.0
    } else if (this.inRange(portfolioCount, 8, 10)) {
      return 18.0
    } else {
      return 18.0
    }
  }

  inRange(x, min, max) {
    return ((x - min) * (x - max) <= 0)
  }

  portfolioAddedElement(portfolioId, portfolioName) {
    return `
      <li data-portfolio-subscription-target="addedPortfolio"
          data-portfolio-id="${portfolioId}">
          ${portfolioName}</li>
    `
  }

  portfolioRemovedElement(portfolioId, portfolioName) {
    return `
      <li data-portfolio-subscription-target="removedPortfolio"
          data-portfolio-id="${portfolioId}">
          ${portfolioName}</li>
    `
  }

  addedCount(count) {
    return `${count} profil${count > 1 ? 's' : ''} ajouté${count > 1 ? 's' : ''} :`
  }

  removedCount(count) {
    return `${count} profil${count > 1 ? 's' : ''} supprimé${count > 1 ? 's' : ''} :`
  }

  loadingElementSm() {
    return `
    <div>
      Chargement en cours...
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    `
  }

  loadingElementSimple() {
    return `
    <div>
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    `
  }

  loadingElement() {
    return `
      <div class="bg-white d-flex justify-content-center align-items-center">
        <div class="spinner-grow text-secondary" role="status" style="width: 6rem; height: 6rem;">
          <span class="sr-only">Chargement...</span>
        </div>
      </div>
    `
  }

  warningStandardPrice() {

  }

  showLoading(el) {
    el.insertAdjacentHTML('beforeend', this.loadingElement())
  }

  hideLoading(el) {
    if (el.querySelector('.loading')) {
      el.querySelector('.loading').remove()
    }
  }

}
